import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-75ec1dda"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "brand" }, null, -1))

import { ref, getCurrentInstance, watch } from 'vue'
import { useRouter } from 'vue-router'
import { 
    NText, NP, NCard, NSpace, NButton
} from 'naive-ui'
import axios from 'axios'
import store from '@/store'

export default /*#__PURE__*/_defineComponent({
  __name: 'EmailVerification',
  props: {
    token: null,
    fromRegister: null
  },
  setup(__props: any) {

const props = __props as {
    token?: string,
    fromRegister?: string
}

const router = useRouter()
const app = getCurrentInstance()
const message = app!.appContext.config.globalProperties.message


const msgRef = ref("")
const resendMail = ref(false)
const resendLoading = ref(false)
const resendDisabled = ref(false)
const resendMsg = ref("Email is not received yet?")
const resendMsgType = ref("")
const resendCoolDown = ref(0)
let coolDownTimeout = ref(0)
function resendCoolDownFunc(val: number, prev: number) {
    if (prev < val) {
        if (coolDownTimeout.value) {
            clearInterval(coolDownTimeout.value)
        }
        coolDownTimeout.value = setInterval(() => {
            resendLoading.value = false
            resendDisabled.value = true
            resendCoolDown.value -= 1
            resendMsgType.value = "error"
            resendMsg.value = `Resend email after ${resendCoolDown.value} seconds`
        }, 1000)
    } else if (!val) {
        clearInterval(coolDownTimeout.value)
        resendLoading.value = false
        resendDisabled.value = false
        resendMsgType.value = ""
        resendMsg.value = `Email is not received yet?`
    }
}
watch(resendCoolDown, resendCoolDownFunc)
function resendClick(e: MouseEvent) {
    resendLoading.value = true
    resendDisabled.value = true
    axios.post("/api/auth/verification/")
    .then(resp => {
        resendLoading.value = false
        resendDisabled.value = true
        resendCoolDown.value = resp.data.timeout
        message.success("Link is successfully sent", {showIcon: true, closable: true})
    })
    .catch(error => {
        if (error.response.status == 409 || error.response.status == 401) {
            router.push("/logout")
            return
        } 
        
        if (error.response.status == 429) {
            resendCoolDown.value = parseInt(error.response.data.detail.match(/\d+/))
            return
        }

        resendLoading.value = false
        resendDisabled.value = false

        message.error("A problem is occurred when sending the link", {showIcon: true, closable: true})
    })
}

if (props.fromRegister) {
    msgRef.value = "Verification email is sent. Please check your email inbox."
    resendMail.value = true
} else if (props.token) {
    axios.get("/api/auth/verification/" + props.token + "/")
    .then(resp => {
        msgRef.value = "Email verification is successful!"
        message.success("Email is successfully verified, please login.", {showIcon: true, closable: true})
        router.push("/logout")
    })
    .catch(error => {
        if ('message' in (error.response.data || {})) {
            msgRef.value = error.response.data.message
        } else {
            msgRef.value = "A problem is occurred"
        }
        message.error("Failed verifying email", {showIcon: true, closable: true})
    })
} else if (store.state.isAuthenticated && !store.state.isEmailVerified) {
    msgRef.value = "Your email is not verified yet. Please check your email inbox untuk menerima link verifikasi email."
    resendMail.value = true
} else {
    router.push("/login")
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(NCard), {
      size: "small",
      style: {"text-align":"center","padding":"2em"}
    }, {
      header: _withCtx(() => [
        _createVNode(_unref(NSpace), {
          id: "form-title",
          vertical: "",
          align: "center",
          size: "small"
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_unref(NP), { style: {"margin-top":"1em"} }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(msgRef.value), 1)
          ]),
          _: 1
        }),
        (resendMail.value)
          ? (_openBlock(), _createBlock(_unref(NSpace), {
              key: 0,
              justify: "end",
              align: "center",
              style: {"margin-top":"2em"}
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(NText), {
                  depth: "3",
                  type: resendMsgType.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(resendMsg.value), 1)
                  ]),
                  _: 1
                }, 8, ["type"]),
                _createVNode(_unref(NButton), {
                  type: "primary",
                  loading: resendLoading.value,
                  disabled: resendDisabled.value,
                  "icon-placement": "left",
                  onClick: resendClick
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Resend link ")
                  ]),
                  _: 1
                }, 8, ["loading", "disabled"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})